const safetyITTabletKeys = {
  all: ['SAFETY_MR'],
  itTabletList: () => [...safetyITTabletKeys.all, 'IT_TABLET_LIST'],
};

export default safetyITTabletKeys;
